@if (dateTime) {
  <div>
    <span class="timeline-date text-muted small">{{ asDate(dateTime, "") }}</span>
    <span class="timeline-time fw-bold text-dark">{{ asTime(dateTime) }}</span>
    <span class="timeline-type text-muted small" style="padding-left:5px">{{ postfix }}</span>
  </div>
}
